import { useTranslation } from "react-i18next";
import { useSubmitContactFormMutation } from "../api/contactApi";
import { useMutationWithFeedback } from "../../../common/hooks/useMutationWithFeedback";
import type {
  ContactFormPayload,
  ContactFormResponse,
} from "../types/contactApiTypes";

export const useSubmitContactForm = () => {
  const { t } = useTranslation();
  const [submitMutation, result] = useSubmitContactFormMutation();

  const {
    trigger: submitContactForm,
    isLoading,
    isSuccess,
  } = useMutationWithFeedback<ContactFormResponse, ContactFormPayload>({
    mutation: [submitMutation, result],
    loadingMessage: t("contactForm.sending", "Sending message..."),
    successMessage: t(
      "contactForm.success",
      "Message sent successfully. We will get back to you soon."
    ),
    errorMessages: {
      default: t(
        "contactForm.error",
        "Failed to send message. Please try again."
      ),
    },
    successToastType: "success",
  });

  return {
    submitContactForm,
    isLoading,
    isSuccess,
    isError: result.isError,
    reset: result.reset,
  };
};
